module.exports = __webpack_public_path__ + "static/media/IEP_Platform_Logo_v03.fb8fca67.png";